export default __webpack_public_path__ + "static/media/movimientos.caa5ff7f.svg";